require('./sctFooter.scss');

const sctFooter = angular.module('app.sct.sctFooter', []);

sctFooter.component('sctFooter', {
  controller: [controller],
  controllerAs: 'vm',
  template: require('./sctFooter.html')
});

function controller() {
  const vm = this;
}

export default sctFooter;


// WEBPACK FOOTER //
// ./src/components/sct/sctFooter/sctFooter.js